import type { ReactNode } from "react";
import { Breadcrumbs, Crumb } from "carbon-react/esm/components/breadcrumbs";
import Typography from "carbon-react/esm/components/typography";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface PageHeadingProps {
  actions?: ReactNode;
  breadcrumbs: BreadcrumbItem[];
  context?: string;
  description?: string;
  onNavigate?(path: string): void;
  title: string;
}

export function PageHeading({ actions, breadcrumbs, context, description, onNavigate, title }: PageHeadingProps) {
  return (
    <header className="page-heading">
      <div className="page-heading__content">
        <Breadcrumbs aria-label="Breadcrumbs">
          {breadcrumbs.map((breadcrumb, index) => {
            const isCurrent = index === breadcrumbs.length - 1;

            return (
              <Crumb
                href={breadcrumb.path}
                isCurrent={isCurrent}
                key={`${breadcrumb.label}-${index}`}
                onClick={breadcrumb.path && !isCurrent
                  ? (event) => {
                      event.preventDefault();
                      onNavigate?.(breadcrumb.path!);
                    }
                  : undefined}
              >
                {breadcrumb.label}
              </Crumb>
            );
          })}
        </Breadcrumbs>
        <div className="page-heading__title-row">
          <Typography variant="h1">{title}</Typography>
          {context ? <Typography className="page-heading__context" variant="p">{context}</Typography> : null}
        </div>
        {description ? <Typography variant="p">{description}</Typography> : null}
      </div>
      {actions ? <div className="page-heading__actions">{actions}</div> : null}
    </header>
  );
}